import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { ExtensionType, settings, extensions as extensions$1 } from '@pixi/core';
var storedGl;
var extensions;
function getCompressedTextureExtensions() {
  extensions = {
    s3tc: storedGl.getExtension("WEBGL_compressed_texture_s3tc"),
    s3tc_sRGB: storedGl.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
    etc: storedGl.getExtension("WEBGL_compressed_texture_etc"),
    etc1: storedGl.getExtension("WEBGL_compressed_texture_etc1"),
    pvrtc: storedGl.getExtension("WEBGL_compressed_texture_pvrtc") || storedGl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
    atc: storedGl.getExtension("WEBGL_compressed_texture_atc"),
    astc: storedGl.getExtension("WEBGL_compressed_texture_astc")
  };
}
var detectCompressedTextures = {
  extension: {
    type: ExtensionType.DetectionParser,
    priority: 2
  },
  test: function () {
    var _test = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var canvas, gl;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            canvas = settings.ADAPTER.createCanvas();
            gl = canvas.getContext("webgl");
            if (gl) {
              _context.next = 5;
              break;
            }
            console.warn("WebGL not available for compressed textures.");
            return _context.abrupt("return", false);
          case 5:
            storedGl = gl;
            return _context.abrupt("return", true);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function test() {
      return _test.apply(this, arguments);
    }
    return test;
  }(),
  add: function () {
    var _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(formats) {
      var textureFormats, extensionName, extension;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!extensions) getCompressedTextureExtensions();
            textureFormats = [];
            _context2.t0 = _regeneratorRuntime.keys(extensions);
          case 3:
            if ((_context2.t1 = _context2.t0()).done) {
              _context2.next = 11;
              break;
            }
            extensionName = _context2.t1.value;
            extension = extensions[extensionName];
            if (extension) {
              _context2.next = 8;
              break;
            }
            return _context2.abrupt("continue", 3);
          case 8:
            textureFormats.push(extensionName);
            _context2.next = 3;
            break;
          case 11:
            return _context2.abrupt("return", [].concat(textureFormats, _toConsumableArray(formats)));
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function add(_x) {
      return _add.apply(this, arguments);
    }
    return add;
  }(),
  remove: function () {
    var _remove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(formats) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!extensions) getCompressedTextureExtensions();
            return _context3.abrupt("return", formats.filter(function (f) {
              return !(f in extensions);
            }));
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function remove(_x2) {
      return _remove.apply(this, arguments);
    }
    return remove;
  }()
};
extensions$1.add(detectCompressedTextures);
export { detectCompressedTextures };